// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"64":"7fdc3de6","143":"2ab1ba19","149":"2e808c6d","162":"836d1fa6","334":"9982f227","409":"e1b605a5","452":"3dfc4f4f","623":"f9b76d39","661":"edb4a861","685":"36f70857","743":"ae72ec65","801":"b06d0689","978":"15bb0632","995":"c564a02d"}[chunkId] + ".js";
};